// import NavPage from "../nav/nav-page";
//import Footer from "../footer";

import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Paper } from "@mui/material";

import TenderTable from "@/app/features/tender/components/view/tender-table-view";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
export default function TenderTablePage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col min-h-screen items-center"
      style={{ background: "#f8fafa !important" }}
    >
      {/* <NavPage isForm={0} /> */}
      <div className="xs:flex xs:flex-col items-right">
        <Paper elevation={0} sx={{ mt: 0, p: 2 }}>
          <div className="flex flex-col">
            <h1 className="sm:text-2xl text-base font-semibold">
              {t("tenders.requests")}
              <button
                style={{ background: "#000", color: "#fff" }}
                onClick={() => navigate("/create-tender")}
                title={t("actions.createNewTender")}
              >
                <AddIcon fontSize="large" />
              </button>
            </h1>
          </div>

          <TenderTable />
        </Paper>
      </div>
    </div>
  );
}
